// Store
import ModalStore from "@/store/modal-store";
import UserStore from "@/store/user-store";
import ModalSheetStore from "@/store/modal-sheet-store";
import ModalConfirmStore from "@/store/modal-confirm-store";
import ConfigStore from "@/store/config-store";

export const useStore = () => {
  return {
    modal: ModalStore(),
    modalConfirm: ModalConfirmStore(),
    modalSheet: ModalSheetStore(),
    user: UserStore(),
    config: ConfigStore(),
  };
};
